import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";

// ------------------ COMPONENTES DE BASE--------------------------
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import { setTitlePage } from "../../../../Base/Services/Config/ConfigService";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import Loader from "../../../../Base/Components/Loader/Loader";
import { InformacionCalendarioMensual } from "../../../../utils/Funciones/FuncionesCalendario"; 

// ------------------ CONSULTAS A LA API --------------------------
import { getHistoricoMP } from "../../../../API/Suministros/Inventario/InventarioRequest";


const InventarioHistoricoTabMP = () => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const [loading, setLoading] = useState(false);
  const [selectedDetalle, setSelectedDetalle] = useState([]);

  const [inventarioH, setInventarioH] = useState([])
  const [mes, setMes] = useState(0);
  const [meses, setMeses] = useState([]);
  const [month, setMonth] = useState(0)
  const [year, setYear] = useState(0);
  const [mostrarDetalle, setMostrarDetalle] = useState(false);


  const getInfo = async (mes, anio) => {
    setLoading(true);
    setSelectedDetalle([]);
    if(mes && anio){
      const result = await getHistoricoMP(mes, anio)
      setInventarioH(result)
    }
    setLoading(false);
  };

  const obtenerCalendarioOperativo = async () => {
    const calendarioMeses = await InformacionCalendarioMensual();
    setMeses(calendarioMeses);
    let year = new Date().getFullYear();
    let mes = new Date().getMonth() + 1;

    let a = calendarioMeses.filter(
      (e) => mes === e.MesNumero && year === e.Anio
    );
    let mesAnterior = new Date().getMonth();
    let b = calendarioMeses.filter(
      (e) => mesAnterior === e.MesNumero && year === e.Anio
    );
    setYear(year);
    setMonth(mes);

    setMes(a[0].IdMes);
    getInfo(mes, year);
    setMeses(calendarioMeses);
  };

  const filtrarMeses = async (Mes) => {
    setLoading(true);
    setMes(Mes);
    let mesSeleccionado = meses.filter((e) => Mes === e.IdMes);
    let mes = mesSeleccionado[0].MesNumero;
    let year = mesSeleccionado[0].Anio;
    setYear(year);
    setMonth(mes);
    getInfo(mes, year);

    setLoading(false);
  };

  const columns = [
    {
      header: "TipoProducto",
      handerEn: "Product Type",
      field: "NombreCategoria",
      className: "small",
      frozen: true,
    },
    {
      header: "Categoría",
      frozen: true,
      handerEn: "Category",
      field: "NombreSubcategoria",
      className: "Xsmall",
    },
    {
      header: "Unidad",
      handerEn: "Unit",
      frozen: true,
      field: "UnitName",
      className: "Xsmall",
    },


    //INICIALES
    {
      headerName: "Iniciales",
      children: [
        {
          header: "Inicial",
          handerEn: "Initial",
          field: "Inicial",
          className: "Xsmall",
          editable: userAuth?.IdRol === 1,
          Sumary: "sum",
          Format: "Currency",
        },
        {
          header: "PrecioL",
          editable: userAuth?.IdRol === 1,
          handerEn: "PriceL",
          field: "PrecioInicialL",
          className: "Xsmall",
          Format: "Currency",
        },
        {
          header: "PrecioD",
          handerEn: "PriceD",
          field: "PrecioInicialD",
          className: "Xsmall",
          editable: userAuth?.IdRol === 1,
          Format: "Currency",
        },
        {
          header: "MontoL",
          handerEn: "MounthL",
          field: "InicialMontol",
          editable: userAuth?.IdRol === 1,
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
        {
          header: "MontoD",
          editable: userAuth?.IdRol === 1,
          handerEn: "MounthD",
          field: "InicialMontoD",
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
      ],
    },

    mostrarDetalle ?
    // COMPRAS REALES
    {
      headerName: "Compras Reales",
      children: [
        {
          header: "ComprasReales",
          handerEn: "Purchase",
          field: "ComprasReales",
          editable: userAuth?.IdRol === 1,
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
        {
          header: "PrecioL",
          handerEn: "PriceL",
          field: "ComprasRealPrecioL",
          className: "Xsmall",
          editable: userAuth?.IdRol === 1,
          Format: "Currency",
        },
        {
          header: "PrecioD",
          handerEn: "PriceD",
          field: "ComprasRealPrecioD",
          editable: userAuth?.IdRol === 1,
          className: "Xsmall",
          Format: "Currency",
        },
        {
          header: "MontoL",
          editable: userAuth?.IdRol === 1,
          handerEn: "MounthL",
          field: "ComprasRealMontoL",
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
        {
          header: "MontoD",
          editable: userAuth?.IdRol === 1,
          handerEn: "MounthD",
          field: "ComprasRealMontoD",
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
      ],
    } : null,

    // COMPRAS
    {
      headerName: "Compras",
      children: [
        {
          header: "Compras",
          handerEn: "Purchase",
          field: "Compras",
          editable: userAuth?.IdRol === 1,
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
        {
          header: "PrecioL",
          editable: userAuth?.IdRol === 1,
          handerEn: "PriceL",
          field: "ComprasPrecioL",
          className: "Xsmall",
          Format: "Currency",
        },
        {
          header: "PrecioD",
          handerEn: "PriceD",
          field: "ComprasPrecioD",
          editable: userAuth?.IdRol === 1,
          className: "Xsmall",
          Format: "Currency",
        },
        {
          header: "MontoL",
          handerEn: "MounthL",
          editable: userAuth?.IdRol === 1,
          field: "ComprasMontoL",
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
        {
          editable: userAuth?.IdRol === 1,
          header: "MontoD",
          handerEn: "MounthD",
          field: "ComprasMontoD",
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
      ],
    },

    mostrarDetalle ?
    //SALIDAS REALES
    {
      headerName: "Salidas Reales",
      children: [
        {
          header: "SalidasReales",
          handerEn: "Output",
          field: "SalidasReales",
          editable: userAuth?.IdRol === 1,
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
        {
          header: "PrecioL",
          editable: userAuth?.IdRol === 1,
          handerEn: "PriceL",
          field: "PrecioSalidaRealL",
          className: "Xsmall",
          Format: "Currency",
        },
        {
          header: "PrecioD",
          handerEn: "PriceD",
          editable: userAuth?.IdRol === 1,
          field: "PrecioSalidaRealD",
          className: "Xsmall",
          Format: "Currency",
        },
        {
          header: "MontoL",
          handerEn: "MounthL",
          field: "MontoSalidaRealL",
          editable: userAuth?.IdRol === 1,
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
        {
          editable: userAuth?.IdRol === 1,
          header: "MontoD",
          handerEn: "MounthD",
          field: "MontoSalidaRealD",
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
      ],
    } : null,

    //SALIDAS
    {
      headerName: "Salidas",
      children: [
        {
          header: "Salidas",
          handerEn: "Output",
          editable: userAuth?.IdRol === 1,
          field: "Salidas",
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
        {
          header: "PrecioL",
          handerEn: "PriceL",
          editable: userAuth?.IdRol === 1,
          field: "PrecioSalidaL",
          className: "Xsmall",
          Format: "Currency",
        },
        {
          header: "PrecioD",
          editable: userAuth?.IdRol === 1,
          handerEn: "PriceD",
          field: "PrecioSalidaD",
          className: "Xsmall",
          Format: "Currency",
        },
        {
          header: "MontoL",
          handerEn: "MounthL",
          editable: userAuth?.IdRol === 1,
          field: "MontoSalidaL",
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
        {
          header: "MontoD",
          editable: userAuth?.IdRol === 1,
          handerEn: "MounthD",
          field: "MontoSalidaD",
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
      ],
    },

    //DEVOLUCION INTERNA
    mostrarDetalle ?
    {
      headerName: "Devolución Interna",
      children: [
        {
          header: "Devolucion Interna",
          handerEn: "",
          field: "DevolucionInterna",
          editable: userAuth?.IdRol === 1,
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
        {
          header: "PrecioL",
          handerEn: "PriceL",
          field: "PrecioDevInternaL",
          editable: userAuth?.IdRol === 1,
          className: "Xsmall",
          Format: "Currency",
        },
        {
          header: "PrecioD",
          handerEn: "PriceD",
          field: "PrecioDevInternaD",
          className: "Xsmall",
          editable: userAuth?.IdRol === 1,
          Format: "Currency",
        },
        {
          header: "MontoL",
          handerEn: "MounthL",
          field: "MontoDevInternaL",
          className: "Xsmall",
          Sumary: "sum",
          editable: userAuth?.IdRol === 1,
          Format: "Currency",
        },
        {
          header: "MontoD",
          editable: userAuth?.IdRol === 1,
          handerEn: "MounthD",
          field: "MontoDevInternaD",
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
      ],
    } : null,

    //DEVOLUCION PROVEEDOR
    mostrarDetalle ?
    {
      headerName: "Devolución Proveedor",
      children: [
        {
          header: "Devolucion Proveedor",
          handerEn: "",
          editable: userAuth?.IdRol === 1,
          field: "DevolucionProveedor",
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
        {
          header: "PrecioL",
          handerEn: "PriceL",
          field: "PrecioDevProveedorL",
          className: "Xsmall",
          editable: userAuth?.IdRol === 1,
          Format: "Currency",
        },
        {
          header: "PrecioD",
          handerEn: "PriceD",
          field: "PrecioDevProveedorD",
          editable: userAuth?.IdRol === 1,
          className: "Xsmall",
          Format: "Currency",
        },
        {
          header: "MontoL",
          editable: userAuth?.IdRol === 1,
          handerEn: "MounthL",
          field: "MontoDevProveedorL",
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
        {
          header: "MontoD",
          handerEn: "MounthD",
          editable: userAuth?.IdRol === 1,
          field: "MontoDevProveedorD",
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
      ],
    } : null,

    //INVENTARIO CALCULADO
    {
      headerName: "Inventario Calculado",
      children: [
        {
          header: "Inv. Calculado",
          handerEn: "",
          field: "InventarioCalculado",
          className: "Xsmall",
          editable: userAuth?.IdRol === 1,
          Sumary: "sum",
          Format: "Currency",
        },
        {
          header: "PrecioL",
          handerEn: "PriceL",
          editable: userAuth?.IdRol === 1,
          field: "InvPrecioL",
          className: "Xsmall",
          Format: "Currency",
        },
        {
          header: "PrecioD",
          handerEn: "PriceD",
          field: "InvPrecioD",
          editable: userAuth?.IdRol === 1,
          className: "Xsmall",
          Format: "Currency",
        },
        {
          header: "MontoL",
          handerEn: "MounthL",
          field: "InvMontoL",
          editable: userAuth?.IdRol === 1,
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
        {
          header: "MontoD",
          editable: userAuth?.IdRol === 1,
          handerEn: "MounthD",
          field: "InvMontoD",
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
      ],
    },

    //INVENTARIO
    {
      headerName: "Inventario",
      children: [
        {
          header: "Inv",
          handerEn: "",
          field: "Inventario",
          className: "Xsmall",
          editable: userAuth?.IdRol === 1,
          Sumary: "sum",
          Format: "Currency",
          frozen: true,
          alignFrozen: "right",
        },
        {
          header: "DIFF",
          handerEn: "",
          field: "DIFF",
          className: "Xsmall",
          editable: userAuth?.IdRol === 1,
          Sumary: "sum",
          Format: "Currency",
          frozen: true,
          alignFrozen: "right",
        },
      ],
    },

    {
      header: "MontoL",
      editable: userAuth?.IdRol === 1,
      handerEn: "MounthL",
      field: "MontoL",
      className: "Xsmall",
      Sumary: "sum",
      Format: "Currency",
      hidden: mostrarDetalle
    },
    {
      header: "MontoD",
      handerEn: "MounthD",
      field: "MontoD",
      editable: userAuth?.IdRol === 1,
      className: "Xsmall",
      Sumary: "sum",
      Format: "Currency",
      hidden: mostrarDetalle,
    },
    {
      editable: userAuth?.IdRol === 1,
      header: "Diff. MontoL",
      handerEn: "",
      field: "MontoLDIFF",
      className: "Xsmall",
      Sumary: "sum",
      Format: "Currency",
      hidden: mostrarDetalle
    },
    {
      header: "Diff. MontoD",
      handerEn: "",
      editable: userAuth?.IdRol === 1,
      field: "MontoDDIFF",
      className: "Xsmall",
      Sumary: "sum",
      Format: "Currency",
      hidden: mostrarDetalle
    },

  ];


  const tableHistorico = {
    Columns: columns,
    Data: inventarioH,
    // loading: loading,
    selected: selectedDetalle,
    setSelected: (e) => setSelectedDetalle(e),
  };

  useEffect(() => {
    getInfo();
    setTitlePage(getLabel(baseLang, "inventarioMP", config.language));
  }, []);

  useEffect(() => {
    let mesSeleccionado = meses.filter((e) => mes === e.IdMes);
    if (mes !== 0) {
      filtrarMeses(mes);
    }
  }, [meses]);

  useEffect(() => {
    obtenerCalendarioOperativo();
  }, []);

  return (
    <div className="mt-2">
      <Toast ref={toast} />
      <Loader loading={loading} querySelector={'#Inv'}/>

      <div className='d-flex flex-row'>
        <Dropdown
          value={mes}
          onChange={(e) => filtrarMeses(e.value)}
          options={meses}
          optionLabel='MesRango'
          optionValue='IdMes'
          style={{ width: 200 }}
        />
        <Button icon='pi pi-refresh' onClick={() => getInfo(month, year)} className='mx-2' loading={loading}/>
        {userAuth.IdRol === 1 && <Button tooltip={mostrarDetalle ? 'Ocultar Detalles' : 'Mostrar Detalles'} onClick={() => { setMostrarDetalle(!mostrarDetalle) }} icon='pi pi-eye' className='mx-2' />}
      </div>

      <div style={{ height: '78vh' }} className='pt-2' id='Inv'>
        <AgGrid table={tableHistorico} />
      </div>

    </div>
  );
};

export default InventarioHistoricoTabMP;
